import React from 'react';
import { BuildRCAttribute } from "@/common/function/RCAttribute";
import { TentativeIcon } from "@/components/ui/Icons/IconsCustom";
import { Text, Tooltip } from "@fluentui/react-components";
import { IIconPermissionTentativeProps } from "@/view/addin/components/icon-permission/Model";
import { EDeclineType } from "@/services/resource-service/entity/Enums";
import { ContentPermissionWrapper } from "@/view/addin/components/icon-permission/Style";
import { renderTextPermission } from "@/view/addin/components/icon-permission/index";
import { useTranslation } from "react-i18next";

const TentativePermission = (props: IIconPermissionTentativeProps) => {
  const { t } = useTranslation();

  const renderContentTentativePermission = (): JSX.Element | string => {
    return <ContentPermissionWrapper className="ContentPermissionWrapper">
      <Text>{t("Booking policy")}:</Text>
      <br />
      <Text>
        {t(renderTextPermission(EDeclineType.TentativeResource))}
      </Text>
    </ContentPermissionWrapper>
  }

  return (
    <Tooltip
      content={renderContentTentativePermission() || ""}
      relationship="label"
    >
      <div {...BuildRCAttribute(`resource_item.permission_tentative`)}>
        <TentativeIcon theme={props.theme} />
      </div>
    </Tooltip>
  );
};

export default TentativePermission;